import React from "react";
import { t } from "@lingui/macro";
import {
  Slider as BaseSlider,
  SliderSlide as BaseSliderSlide,
  SliderProps
} from "@silversea-ssc/ui-components-react";
import { dispatchTrackingEvent } from "src/utils/analytics";

const Slider: React.FC<SliderProps> = ({ children, ...props }) => {
  return (
    <BaseSlider
      {...props}
      labels={{
        goToPage: t`Go to page`,
        previous: t`Previous`,
        next: t`Next`,
        counterSeparator: t`count-separator-xx-of-xx`
      }}
      onSlideChange={(slideNumber) => {
        dispatchTrackingEvent("slider_slide_changed", {
          value: slideNumber
        });
      }}
    >
      {children}
    </BaseSlider>
  );
};

const SliderSlide = BaseSliderSlide;
export { SliderSlide };
export default Slider;
